import { render, staticRenderFns } from "./SubjectFormModal.vue?vue&type=template&id=0a45aa67"
import script from "./SubjectFormModal.vue?vue&type=script&lang=js"
export * from "./SubjectFormModal.vue?vue&type=script&lang=js"
import style0 from "./SubjectFormModal.vue?vue&type=style&index=0&id=0a45aa67&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a45aa67')) {
      api.createRecord('0a45aa67', component.options)
    } else {
      api.reload('0a45aa67', component.options)
    }
    module.hot.accept("./SubjectFormModal.vue?vue&type=template&id=0a45aa67", function () {
      api.rerender('0a45aa67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/modal/SubjectFormModal.vue"
export default component.exports